export default {
    name: "get_account_by_name",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'get account ID by %1name',
                "args0": [
                    {
                        "type": "input_value",
                        "name": "NAME",
                        "check": "String"
                    }
                ],
                "output": "Account_Id",
                "colour": 4.5,
                "tooltip": "Returns account from local cache by name",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        // String or array length.
        let params = ["NAME"];

        params = params.map(param => blocklyInstance.JavaScript.valueToCode(block, param,
            blocklyInstance.JavaScript.ORDER_ATOMIC));

        return [`getAccountByName(${params.join(",")})`, blocklyInstance.JavaScript.ORDER_NONE];
    }
}